import { Card } from "@/components/ui/card";

const NewsCardSkeleton = () => {
  return (
    <Card className="p-6 overflow-hidden relative">
      <div className="space-y-4">
        {/* Source Badge & Link */}
        <div className="flex items-center justify-between">
          <div className="h-5 w-24 bg-muted rounded-full animate-pulse" />
          <div className="h-4 w-28 bg-muted rounded animate-pulse" />
        </div>
        
        {/* Headline */}
        <div className="space-y-2">
          <div className="h-6 w-full bg-muted rounded animate-pulse" />
          <div className="h-6 w-3/4 bg-muted rounded animate-pulse" />
        </div>
        
        {/* Key Takeaways */}
        <div className="space-y-2">
          <div className="h-4 w-32 bg-muted rounded animate-pulse" />
          <div className="space-y-1">
            <div className="flex gap-2">
              <div className="h-4 w-2 bg-muted rounded-full animate-pulse" />
              <div className="h-4 flex-1 bg-muted rounded animate-pulse" />
            </div>
            <div className="flex gap-2">
              <div className="h-4 w-2 bg-muted rounded-full animate-pulse" />
              <div className="h-4 flex-1 bg-muted rounded animate-pulse" />
            </div>
            <div className="flex gap-2">
              <div className="h-4 w-2 bg-muted rounded-full animate-pulse" />
              <div className="h-4 w-2/3 bg-muted rounded animate-pulse" />
            </div>
          </div>
        </div>
        
        {/* AI Insight */}
        <div className="border-l-2 border-muted pl-4 space-y-2">
          <div className="h-4 w-24 bg-muted rounded animate-pulse" />
          <div className="space-y-1">
            <div className="h-4 w-full bg-muted rounded animate-pulse" />
            <div className="h-4 w-5/6 bg-muted rounded animate-pulse" />
          </div>
        </div>
        
        {/* Timestamp */}
        <div className="flex items-center gap-2">
          <div className="h-3 w-3 bg-muted rounded-full animate-pulse" />
          <div className="h-3 w-32 bg-muted rounded animate-pulse" />
        </div>
      </div>
      
      {/* Shimmer overlay effect */}
      <div className="absolute inset-0 -translate-x-full animate-[shimmer_2s_infinite] bg-gradient-to-r from-transparent via-white/10 to-transparent" />
    </Card>
  );
};

export default NewsCardSkeleton;
